import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { colors } from 'styles/colors';

interface IHomeTabsProps {
  activeTab: 'mainStream' | 'following';
  onTabChange: (tab: 'mainStream' | 'following') => void;
}

const HomeTabs: React.FC<IHomeTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: colors.background.white,
        borderBottom: `1px solid ${colors.border.primary}`,
        borderTop: `1px solid ${colors.border.primary}`
      }}
    >
      <Box sx={{ px: { xs: '12px', sm: '24px' } }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => onTabChange(newValue)}
          variant="fullWidth"
          sx={{
            minHeight: '44px',
            '& .MuiTabs-indicator': {
              backgroundColor: colors.text.primaryTheme,
              height: '2px',
              bottom: 0
            }
          }}
        >
          <Tab
            label="Main Stream"
            value="mainStream"
            sx={{
              textTransform: 'none',
              fontSize: '15px',
              fontWeight: 600,
              color: colors.text.darkGray,
              '&.Mui-selected': {
                color: colors.text.primaryTheme
              },
              minHeight: '44px'
            }}
          />
          <Tab
            label="Following"
            value="following"
            sx={{
              textTransform: 'none',
              fontSize: '15px',
              fontWeight: 600,
              color: colors.text.darkGray,
              '&.Mui-selected': {
                color: colors.text.primaryTheme
              },
              minHeight: '44px'
            }}
          />
        </Tabs>
      </Box>
    </Box>
  );
};

export default HomeTabs;
